import { lazy, Suspense } from "react";
import type { Props as ApexProps } from "react-apexcharts";

const ReactApexChart = lazy(() => import("react-apexcharts"));

// Animations coupées par défaut (options globales `window.Apex`, lues par
// ApexCharts à chaque création de graphe). Quand les données changent pendant
// une animation (refetch, temps réel) avec un nombre de points différent,
// l'interpolation de chemin d'ApexCharts lève « s[n] is undefined » : 20
// utilisateurs touchés sur le dashboard en octobre 2026 (PostHog). La plupart
// des widgets posaient déjà `animations: { enabled: false }` ; ceci couvre les autres.
if (typeof window !== "undefined") {
  const w = window as unknown as { Apex?: { chart?: Record<string, unknown> } };
  w.Apex = { ...w.Apex, chart: { ...w.Apex?.chart, animations: { enabled: false } } };
}

type ChartSkeletonProps = { height?: number | string };

function ChartSkeleton({ height = 200 }: ChartSkeletonProps) {
  return (
    <div
      className="w-full animate-pulse rounded-lg bg-muted/40"
      style={{ height: typeof height === "number" ? height : height }}
    />
  );
}

export default function LazyApexChart(props: ApexProps) {
  return (
    <Suspense fallback={<ChartSkeleton height={props.height} />}>
      <ReactApexChart {...props} />
    </Suspense>
  );
}
